import "../k";
import { LEVELS } from "../data";
import { getLevelStateInfo } from "../scenes/levelSelect";
import { unlockUserAchievement } from "../achievementRelay";
import { addButton } from "../things/button";
import { goTransition } from "../util/goTransition";
import { saveBestScore, getBestScore } from "../util/storage";
import { QUIZ_PINK } from "../util/style";

scene("end", (score: number, levelIndex: number) => {
  const currentLevel = LEVELS[levelIndex];
  add([
    text(`Score: ${score}/${currentLevel.questions.length}`, {
      size: 64,
      font: "rumeur",
    }),
    pos(width() / 2, height() / 2 - 40),
    anchor("center"),
    color(Color.BLACK),
  ]);

  const previousBestScore = getBestScore(currentLevel.fileName);
  const isNewHighScore =
    previousBestScore === null || score > previousBestScore;

  if (isNewHighScore) {
    play("win", { volume: 0.5 });

    add([
      text("NEW HIGH SCORE!", {
        size: 36,
        font: "rumeur",
      }),
      pos(width() / 2, height() / 2 + 20),
      anchor("center"),
      color(QUIZ_PINK),
    ]);

    const nextLevelIndex = levelIndex + 1;
    const nextLevelStateInfoPrev = getLevelStateInfo(nextLevelIndex);
    saveBestScore(currentLevel.fileName, score);
    const nextLevelStateInfo = getLevelStateInfo(nextLevelIndex);

    if (nextLevelIndex < LEVELS.length) {
      if (
        nextLevelStateInfoPrev.state === "locked" &&
        nextLevelStateInfo.state === "unlocked"
      ) {
        add([
          text(`Level unlocked: ${LEVELS[nextLevelIndex].name}!`, {
            size: 24,
            font: "rumeur",
          }),
          pos(width() / 2, height() / 2 + 60),
          anchor("center"),
          color(Color.BLACK),
        ]);
      }
    }
  }

  const playAgainButton = addButton("button", [
    pos(width() / 2, height() / 2 + 160),
    area(),
    { textContents: "Back" },
    "playAgainButton",
  ]);

  playAgainButton.onClick(() => {
    goTransition("levelSelect");
  });

  if (score >= 7) unlockUserAchievement("ai-sleuth");
  if (score >= 10) unlockUserAchievement("ai-sherlock");
});
